SNI.Application.addModule('card', context => {
  return {};
});